const urlBuildersByProvider = {
    'vimeo': (id) => `https://player.vimeo.com/video/${id}`,
    'youtube': (id) => `https://www.youtube.com/embed/${id}`,
}

export const createVideoUrl = (video) => {
    if (typeof video.video_id === 'string' && video.video_id) {
        const [provider, id] = video.video_id.split(':');

        if (typeof urlBuildersByProvider[provider] === 'function') {
            return urlBuildersByProvider[provider](id);
        }
    }

    if (video.vimeo_id) {
        return urlBuildersByProvider['vimeo'](video.vimeo_id);
    }

}

export const getVideoThumbnailPath = (video) => {
    if (!video.id) {
        return;
    }
    return `/api/ch/videothumb/${video.id}`;
}
